import { IResourceList } from 'src/components/challenge/ChallengeInterfaces';
import { ResourceTypeDetailEnum } from 'src/shared/enums';
import { IHiddenItem } from 'src/shared/models';

const {
  HIDDEN_TITLE,
  HIDDEN_ICON,
  HIDDEN_TEXT,
  HIDDEN_BUTTON_TEXT,
  HIDDEN_CTA_TEXT,
  HIDDEN_CTA_LINK,
} = ResourceTypeDetailEnum;

export const buildChallengeHidden = (resource: IResourceList): IHiddenItem => {
  const { resourceDetailList, idResource } = resource;

  let item: IHiddenItem;

  resourceDetailList
    .filter(({ status }) => status)
    .forEach(({ idResourceTypeD: { idResourceTypeD }, value }) => {
      switch (idResourceTypeD) {
        case HIDDEN_TITLE:
          item = {
            ...item,
            title: value,
          };
          break;
        case HIDDEN_ICON:
          item = {
            ...item,
            icon: value,
          };
          break;
        case HIDDEN_TEXT:
          item = {
            ...item,
            text: value,
          };
          break;
        case HIDDEN_BUTTON_TEXT:
          item = {
            ...item,
            buttonText: value,
          };
          break;
        case HIDDEN_CTA_TEXT:
          item = {
            ...item,
            ctaText: value,
          };
          break;
        case HIDDEN_CTA_LINK:
          item = {
            ...item,
            ctaLink: value,
          };
          break;
        default:
          break;
      }
    });

  return {
    ...item,
    idResource,
  };
};
